import React from 'react';
import _get from 'lodash/get';

import { If } from 'utils';
import { FeatureUpsell, PageScroll, UiKit } from 'components';
import { InfoLink } from 'components/Tables/CustomTable';
import { useRetailer } from 'utils/hooks';
import { createTooltipId } from '../../methods';

export default function Card({
  data = {},
  index = 0,
  disabled = false,
  onToggle = () => {}
}) {
  const { isSSRStore } = useRetailer();

  const id = _get(data, 'id', '');
  const title = _get(data, 'title', '');
  const isLocked = _get(data, 'isLocked', '');
  const isEnabled = _get(data, 'is_enabled', false);
  const description = _get(data, 'description', '');
  const docUrl = _get(data, 'documentation_url', '');
  const featureType = _get(data, 'feature_type', '');
  const featureSlug = _get(data, 'feature_slug', false);
  const hyperlink = _get(data, 'hyperlinks', {});

  const tooltipId = createTooltipId(title);
  const hashId = featureType.replace(/_/g, '-');

  // Function to render description with hyperlinks
  const renderDescriptionWithLinks = () => {
    if (!hyperlink.text || !hyperlink.link) {
      return <p>{description}</p>;
    }

    const linkText = hyperlink.text;
    const linkUrl = hyperlink.link;

    // Split description by the hyperlink text
    const parts = description.split(linkText);

    if (parts.length === 1) {
      // No hyperlink text found in description
      return <p>{description}</p>;
    }

    // Create inline elements without fragments
    const elements = [];
    parts.forEach((part, index) => {
      elements.push(part);
      if (index < parts.length - 1) {
        elements.push(
          <a
            key={`link-${index}`}
            href={linkUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkText}
          </a>
        );
      }
    });

    return <p>{elements}</p>;
  };

  return (
    <li
      style={{ animationDelay: `${index * 0.08}s` }}
      className="additional-features__listItem"
    >
      <PageScroll.Section
        hashId={hashId}
        disableHighlight
        className="additional-features__section"
      >
        <div className="additional-features__highlightWrapper">
          <PageScroll.Highlight
            delay={700}
            className="additional-features__highlight"
          >
            <FeatureUpsell.Container
              hasAccess={!isLocked}
              className="additional-features__listItem--container"
            >
              <div className="additional-features__listItem--content">
                <div className="additional-features__listItem--header">
                  <h5>{title}</h5>
                  <If test={!isLocked} otherwise={<FeatureUpsell.LockBadge />}>
                    <UiKit.Toggle
                      isActive={isEnabled}
                      onChange={() => onToggle(id)}
                      disabled={disabled}
                    />
                  </If>
                </div>
                <div className="additional-features__listItem--description">
                  {/* <span>Description</span> */}
                  {renderDescriptionWithLinks()}
                </div>
              </div>
              <div className="additional-features__listItem--footer">
                <div className="additional-features__listItem--upsellBtn">
                  <If test={featureSlug}>
                    <FeatureUpsell.Modal.Trigger featureSlug={featureSlug} />
                  </If>
                </div>
                <If test={!isSSRStore}>
                  <InfoLink
                    url={docUrl}
                    id={tooltipId}
                    // placement="left"
                  />
                </If>
              </div>
            </FeatureUpsell.Container>
          </PageScroll.Highlight>
        </div>
      </PageScroll.Section>
    </li>
  );
}
